module.exports = __webpack_public_path__ + "img/btn_点击查看.9e305a27.png";